import Axios from 'axios';
import * as ApiHelper from '../utils/apiHelper';
import * as TokenHelpers from '../utils/tokenHelpers';

export function addRating(data) {

    let path = ApiHelper.API_ROOT + '/rating/star';
    return new Promise((resolve, reject) => {
        let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
        Axios({
            url: path,
            method: 'POST',
            data: data,
            headers: headers
        })    
            .then(function (response) {
                resolve(response.data);
            }).catch(ApiHelper.handleUserAuth).catch(function (error) {
                reject({ error: error.response.data });
            });   
    });
}


// WEBPACK FOOTER //
// ./src/services/rating.js